import { createViewSettings } from "@/ui/views";
import type { TCompositionDeps } from "./types";
import { wireSettingsChartOfAccounts } from "./wireSettingsChartOfAccounts";
import { wireSettingsPropertyCodes } from "./wireSettingsPropertyCodes";
import { wireSettingsBooks } from "./wireSettingsBooks";
import { wireSettingsSegmentValues } from "./wireSettingsSegmentValues";
import { wireSettingsCompany } from "./wireSettingsCompany";
import { wireSettingsYardiImport } from "./wireSettingsYardiImport";

export const wireSettings = (deps: TCompositionDeps) => {
    const ViewSettings = createViewSettings();
    const { ViewChartOfAccounts } = wireSettingsChartOfAccounts(deps);
    const { ViewPropertyCodes } = wireSettingsPropertyCodes(deps);
    const { ViewBooks } = wireSettingsBooks(deps);
    const { ViewSegmentValues } = wireSettingsSegmentValues(deps);
    const { ViewCompanySettings } = wireSettingsCompany(deps);
    const { ViewYardiImport } = wireSettingsYardiImport(deps);

    return {
        ViewSettings,
        ViewChartOfAccounts,
        ViewPropertyCodes,
        ViewBooks,
        ViewSegmentValues,
        ViewCompanySettings,
        ViewYardiImport,
    };
};
